import React, { useState } from 'react';
import { ListItemText, Collapse, List, ListItemButton, Typography, Box, Stack } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { DBHistory } from '../../../models/history';

interface HistoryListItemProps {
  historyItem: DBHistory;
}

export const HistoryListItem: React.FC<HistoryListItemProps> = ({ historyItem }) => {
  const [open, setOpen] = useState(false);
  const [expandedEntries, setExpandedEntries] = useState<Set<number>>(new Set());

  const toggleEntry = (index: number) => {
    setExpandedEntries(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  return (
    <Box width={'100%'}>
    <Stack direction={'column'}>
      <ListItemButton onClick={() => setOpen(!open)}>
        <ListItemText
          primary={`Entry: ${historyItem.entry} | Type: ${historyItem._type || 'N/A'}`}
          secondary={`Created: ${historyItem.created || 'N/A'} | Updated: ${historyItem.updated || 'N/A'}`}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List disablePadding>
          {historyItem.history.map((entry, index) => (
            <Box key={index}>
              <ListItemButton onClick={() => toggleEntry(index)} sx={{ pl: 4 }}>
                <ListItemText
                  primary={`User: ${entry.user} | Method: ${entry.method}`}
                  secondary={`Timestamp: ${entry.ts}`}
                />
                {expandedEntries.has(index) ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={expandedEntries.has(index)} timeout="auto" unmountOnExit>
                <Box sx={{ pl: 6 }}>
                  {entry.create && (
                    <Typography variant="body2">Create: {entry.create.join(', ')}</Typography>
                  )}
                  {entry.update && (
                    <Typography variant="body2">Update: {entry.update.join(', ')}</Typography>
                  )}
                  {entry.delete && (
                    <Typography variant="body2">Delete: {entry.delete.join(', ')}</Typography>
                  )}
                  {entry.read && (
                    <Typography variant="body2">Read: {entry.read.join(', ')}</Typography>
                  )}
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Collapse>
      </Stack>
    </Box>
  );
};
